import { isEmpty, isPresent } from '@ember/utils';
import { assignSingleProperty } from 'donor-elf-web/lib/object-utils';
import {
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';
import type { ValidationResult } from 'ember-changeset/types';

export default {
  actionId: validatePresence({ presence: true, message: "Can't be blank" }),
  summary: validateLength({
    max: 1024,
    message: "Can't be longer than 1024 characters",
  }),
  contactId: (
    _key: string,
    newValue: string,
    _oldValue: string,
    changes: any,
    content: any,
  ): ValidationResult => {
    let contactIds = assignSingleProperty(content, changes, 'contactIds');
    if (isEmpty(contactIds) && isEmpty(newValue)) {
      return "Can't be blank";
    }
    return true;
  },
  journalStageId: (
    _key: string,
    newValue: string,
    _oldValue: string,
    changes: any,
    content: any,
  ): ValidationResult => {
    let journalId = assignSingleProperty(content, changes, 'journalId');
    if (isPresent(journalId) && isEmpty(newValue)) {
      return "Can't be blank since a Journal was selected";
    }
    return true;
  },
};
